var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRightArrow = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M511.189 259.954c1.649-3.989.731-8.579-2.325-11.627l-192-192c-4.237-4.093-10.99-3.975-15.083.262-3.992 4.134-3.992 10.687 0 14.82l173.803 173.803H10.667C4.776 245.213 0 249.989 0 255.88c0 5.891 4.776 10.667 10.667 10.667h464.917L301.803 440.328c-4.237 4.093-4.355 10.845-.262 15.083 4.093 4.237 10.845 4.354 15.083.262.089-.086.176-.173.262-.262l192-192c.986-.991 1.769-2.165 2.303-3.457z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M309.333 458.546c-5.891.011-10.675-4.757-10.686-10.648-.005-2.84 1.123-5.565 3.134-7.571l184.47-184.447-184.47-184.448c-4.093-4.237-3.975-10.99.262-15.083 4.134-3.992 10.687-3.992 14.82 0l192 192c4.164 4.165 4.164 10.917 0 15.083l-192 192c-1.998 1.994-4.706 3.114-7.53 3.114z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M501.333 266.546H10.667C4.776 266.546 0 261.771 0 255.88s4.776-10.667 10.667-10.667h490.667c5.891 0 10.667 4.776 10.667 10.667-.001 5.891-4.777 10.666-10.668 10.666z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRightArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/rightArrow.b2f4a764.svg";
export { ForwardRef as ReactComponent };